var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBottomHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 68",
    cx: 32,
    cy: 32,
    r: 32,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2019"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 390"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 386"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 389"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uBE7C\\uAE30 1",
    d: "M21170 1102a12.007 12.007 0 1 1 8.486-3.516A12.015 12.015 0 0 1 21170 1102zm2.5-8.476a.853.853 0 0 0-.828 1.092 2.767 2.767 0 0 0 1.648 1.861 2.466 2.466 0 0 0 2.223-.229 2.908 2.908 0 0 0 1.313-2.823.855.855 0 1 0-1.711 0c0 1.048-.25 1.208-.516 1.376a.806.806 0 0 1-.424.126.758.758 0 0 1-.273-.051 1.076 1.076 0 0 1-.611-.728.854.854 0 0 0-.821-.621zm.07-4.809a.856.856 0 0 0-.855.856v2.142a.858.858 0 0 0 1.717 0v-2.142a.86.86 0 0 0-.862-.852zm3-1.286a.86.86 0 0 0-.861.856v2.142a.858.858 0 0 0 1.717 0v-2.142a.856.856 0 0 0-.852-.853z",
    transform: "translate(-21138.003 -1058.001)",
    style: {
      fill: "#fff",
      stroke: "transparent",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 712",
    d: "M7.213 23.75c.838.765 1.2 1.729.816 2.154s-1.382.15-2.219-.615-1.2-1.729-.816-2.154 1.381-.15 2.219.615",
    transform: "translate(18.983 11.151)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 713",
    d: "M7.593 26.789c.838.765 1.2 1.729.816 2.154s-1.382.15-2.219-.615-1.2-1.729-.816-2.154 1.381-.15 2.219.615",
    transform: "translate(19.032 11.541)",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 714",
    d: "M11.012 26.789c.838.765 1.2 1.729.816 2.154s-1.382.15-2.219-.615S8.4 26.6 8.793 26.174s1.381-.15 2.219.615",
    transform: "translate(19.47 11.541)",
    style: {
      fill: "#f2f2f2"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomHome);
export default __webpack_public_path__ + "static/media/bottom_home.1cc9988d4d9e9974b393b014eace7c08.svg";
export { ForwardRef as ReactComponent };